export default "__VITE_ASSET__88737aee__"